import styled from 'styled-components';

const TopSectionStyle = styled.div`
	.topWrap {
		--titleWrapMargin: var(--sp4x);

		position: relative;

		.titleWrap {
			margin-top: var(--titleWrapMargin);

			.title {
				span {
					display: block;
					opacity: 0;
				}
			}
		}

		.subtitleWrap {
			margin-top: var(--titleToText);

			.subtitle {
				span {
					display: block;
					opacity: 0;
				}
			}
		}

		.secondIconCont {
			margin-top: var(--sp6x);
			width: var(--sp22x);
			height: var(--sp10x);
			opacity: 0;
			border-bottom: 4px solid rgba(0, 0, 0, 0);
		}
	}

	.descriptionWrap {
		opacity: 0;
		margin-bottom: var(--titleToText);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.MobileSize}) {
		.topWrap {
			--titleWrapMargin: var(--sp4x);

			.secondIconCont {
				margin-top: var(--sp11x);
				height: var(--sp28x);
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		.topWrap {
			--titleWrapMargin: var(--sp3x);

			.secondIconCont {
				margin-top: var(--sp6x);
				height: var(--sp25x);
				width: var(--sp44x);
				border-bottom-width: 6px;
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		.topWrap {
			.subtitleWrap {
				text-align: right;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		.topWrap {
			.secondIconCont {
				width: var(--sp44x);
				margin-top: var(--sp8x);
				height: 0px;
				border-bottom-width: 6px;
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		.topWrap {
			--titleWrapMargin: var(--sp1x);

			.secondIconCont {
				height: 0px;
				border-bottom-width: 6px;
			}
		}

		.descriptionWrap {
			.description {
				max-width: 86.5%;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		.topWrap {
			.secondIconCont {
				margin-top: var(--sp8x);
				width: var(--sp52x);
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		.topWrap {
			--titleWrapMargin: calc(var(--sp2x) * -1);

			.secondIconCont {
				margin-top: var(--sp6x);
				width: 420px;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		.topWrap {
			--titleWrapMargin: var(--sp1x);

			.secondIconCont {
				margin-top: var(--sp9x);
				width: 445px;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		.topWrap {
			--titleWrapMargin: 0px;

			.secondIconCont {
				margin-top: var(--sp14x);
				width: var(--sp75x);
				border-bottom-width: 8px;
			}
		}

		.descriptionWrap {
			.description {
				max-width: 90%;
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
		.topWrap {
			--titleWrapMargin: calc(var(--sp2-5x) * -1);

			.secondIconCont {
				margin-top: var(--sp18x);
				width: 700px;
				border-bottom-width: 12px;
			}
		}

		.descriptionWrap {
			.description {
				max-width: 90%;
			}
		}
	}
`;

export default TopSectionStyle;
